module.exports = __webpack_public_path__ + "static/img/07003B_1_R_20200922_fit.68e42b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/07003B_1_R_20200922_fit.png
// module id = 7p9J
// module chunks = 0